import React from "react";
import { formatPrice } from "../../../../../../../../common-deprecated/Globalize";
import Icon from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import type { BuildAndBuyLabelType } from "../../../../../utils/labels";
import { bnbIntegratedTradeInNotificationsLabels, BnbLabel } from "../../../../../utils/labels";
import type { BuildAndBuyDispatchType } from "../../../../../redux/store";
import { useBnbSelector } from "../../../../../redux/store";
import * as BasketTradeInStyles from "../styles/BasketTradeIn";
import { showPrice } from "../../../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";
import {
    clearTradeInAemExtData,
    setTradeInNotification,
} from "../../../../../../../../common-deprecated/features/tradein/redux/actions/TradeInAemExternalDataActions";
import { MODAL_INTEGRATED_TRADE_IN_AEM } from "../../../../../../../../shared-logic/features/tradein/utils/integratedModalConstants";
import { showModal } from "../../../../../../../../common-deprecated/redux/actions/ModalActions";
import { trackCtaCalculator } from "../../../../../utils/tracking";
import { Ellipsis } from "../../../../../../../../common-deprecated/styles/v2/lexus/utilities/Ellipsis";
import { IconWrapper } from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import ButtonOutlineLight from "../../../../../../../../common-deprecated/components/aem/lexus/button/ButtonOutlineLight";
import IconPartExchange from "../../../../../../../../common-deprecated/svg/lexus/aem/part-exchange.svg";
import { useDispatch } from "../../../../../../../../shared-logic/redux/store";

/**
 * TODO OR-8912 - Align notifications
 */
const TradeInDetails = (): JSX.Element | null => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const notification = useBnbSelector(
        (state) => state.tradeInAemExternalData.notification[state.utils.financeOption],
    );
    const { vehicleName, vehicleValue, licensePlate, vin } = useBnbSelector(
        (state) => state.tradeInAemExternalData.data,
    );
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const step = useBnbSelector((state) => state.navigation.step);

    const vehicleTitle = vehicleName ? `${vehicleName.name} ${vehicleName?.description || ""}` : "";
    const vehiclePlate = licensePlate || vin || "";

    const showContent = !!vehicleTitle && !!vehicleValue && !notification.isError;

    // Some labels here are from tradein settings as this component is only shown when integrated tradein is active.
    // Because of this it is easier to just cast it for now
    const showNotification = notification.notificationType && notification.show;

    const tooHighLabel: BuildAndBuyLabelType =
        financeOption === "cash" ? "tradeinBasketTooHighCash" : "tradeinBasketTooHighMonthly";

    const formattedPrice = formatPrice(vehicleValue || 0, commonSettings.culture.name).replace(" ", "&nbsp;");
    const showPrices = showPrice(commonSettings);

    if (!showPrices) return null;

    return (
        <>
            <BasketTradeInStyles.TradeInNotificationWrapper show={!!showNotification}>
                <BasketTradeInStyles.TradeInNotificationModal show={!!showNotification}>
                    <BasketTradeInStyles.TradeInNotificationHeader>
                        <BasketTradeInStyles.TradeInNotificationTitle>
                            <BnbLabel label={"tradeinBasketUpdate" as any} />
                        </BasketTradeInStyles.TradeInNotificationTitle>
                        <button
                            type="button"
                            onClick={() => {
                                dispatch(setTradeInNotification(financeOption, false));
                            }}
                        >
                            <IconWrapper>
                                <Icon variant="close" />
                            </IconWrapper>
                        </button>
                    </BasketTradeInStyles.TradeInNotificationHeader>
                    <BasketTradeInStyles.TradeInNotificationBody>
                        {notification.notificationType && (
                            <BnbLabel label={bnbIntegratedTradeInNotificationsLabels[notification.notificationType]} />
                        )}
                    </BasketTradeInStyles.TradeInNotificationBody>
                </BasketTradeInStyles.TradeInNotificationModal>
            </BasketTradeInStyles.TradeInNotificationWrapper>

            {showContent && !showNotification && (
                <BasketTradeInStyles.Wrapper>
                    <BasketTradeInStyles.Header>
                        <BasketTradeInStyles.Title>
                            <BnbLabel label="partExchangeTitle" />
                        </BasketTradeInStyles.Title>
                        <BasketTradeInStyles.TradeInValue>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: `${financeOption === "cash" ? "- " : ""}${formattedPrice}`,
                                }}
                            />
                            <button
                                type="button"
                                onClick={(event) => {
                                    event.preventDefault();
                                    dispatch(clearTradeInAemExtData());
                                }}
                            >
                                <IconWrapper>
                                    <Icon variant="close" />
                                </IconWrapper>
                            </button>
                        </BasketTradeInStyles.TradeInValue>
                    </BasketTradeInStyles.Header>
                    <BasketTradeInStyles.Body>
                        {notification.isError ? (
                            <BnbLabel label={tooHighLabel} />
                        ) : (
                            <span>
                                {vehicleTitle}
                                {vehiclePlate && (
                                    <>
                                        <br />
                                        {vehiclePlate}
                                    </>
                                )}
                            </span>
                        )}
                    </BasketTradeInStyles.Body>
                </BasketTradeInStyles.Wrapper>
            )}

            <BasketTradeInStyles.Actions>
                <ButtonOutlineLight
                    fullWidth
                    onClick={() => {
                        trackCtaCalculator(step, "tradein-calculator");
                        dispatch(showModal({ type: MODAL_INTEGRATED_TRADE_IN_AEM }));
                    }}
                >
                    <IconWrapper>
                        <IconPartExchange />
                    </IconWrapper>
                    <Ellipsis maxWidth="100%">
                        <BnbLabel label={vehicleName ? "editPartExchange" : "partExchange"} />
                    </Ellipsis>
                    <IconWrapper>
                        <Icon variant="arrowRight" />
                    </IconWrapper>
                </ButtonOutlineLight>
            </BasketTradeInStyles.Actions>
        </>
    );
};

export default TradeInDetails;
